import { combineReducers } from '@reduxjs/toolkit';

import csvUpload from '@occc-app/routes/Segment/components/CSVUpload/redux';
import productGroups from '@occc-app/Offer/ProductGroups/redux';
import { reducer as offer } from '@occc-app/Offer/redux';
import offers from '@occc-app/Offers/redux';
import segment from '@occc-app/routes/Segment/redux';

import { State } from './types';

export default () =>
  combineReducers<State>({
    csvUpload,
    productGroups,
    offer,
    offers,
    segment,
  });
